const Skeleton = ({ width = '100%', height = 20, borderRadius = 4, style = {} }) => (
  <div style={{
    width,
    height,
    borderRadius,
    background: 'linear-gradient(90deg, var(--navy-3) 25%, var(--navy-4) 50%, var(--navy-3) 75%)',
    backgroundSize: '200% 100%',
    animation: 'shimmer 1.5s infinite',
    flexShrink: 0,
    ...style,
  }} />
);

export const PatientCardSkeleton = () => (
  <div style={{ padding: '12px 16px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', gap: 10 }}>
    <Skeleton width={30} height={30} borderRadius={15} />
    <div style={{ flex: 1 }}>
      <Skeleton height={13} width="55%" style={{ marginBottom: 6 }} />
      <Skeleton height={11} width="35%" />
    </div>
    <Skeleton height={11} width={60} />
  </div>
);

export const NoteCardSkeleton = () => (
  <div style={{ padding: '11px 14px', borderBottom: '1px solid var(--border)' }}>
    <Skeleton height={13} width="50%" style={{ marginBottom: 7 }} />
    <Skeleton height={11} width="70%" style={{ marginBottom: 5 }} />
    <Skeleton height={10} width="40%" />
  </div>
);

export const LabRowSkeleton = () => (
  <div style={{ padding: '10px 16px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', gap: 12 }}>
    <Skeleton height={12} width="25%" />
    <Skeleton height={12} width="20%" />
    <Skeleton height={12} width="15%" style={{ marginLeft: 'auto' }} />
  </div>
);

export const DashboardWidgetSkeleton = () => (
  <div className="stat-card">
    <Skeleton height={11} width="50%" style={{ marginBottom: 10 }} />
    <Skeleton height={26} width="40%" style={{ marginBottom: 6 }} />
    <Skeleton height={10} width="60%" />
  </div>
);

export default Skeleton;
